module.exports = __webpack_public_path__ + "static/js/0.7b54d1a1.chunk.worker.js"